import React from 'react';

export default class Duvidas extends React.Component {

    render(){

        return (
          <>


            <section className="page-section portfolio" id="duvidas">
                <div className="container">

                <h2 className="page-section-heading text-center text-uppercase text-secondary mb-0">Principais Dúvidas</h2>

                <div className="divider-custom">
                    <div className="divider-custom-line"></div>
                    <div className="divider-custom-icon">
                    <i className="fa fa-star"></i>
                    </div>
                    <div className="divider-custom-line"></div>
                </div>

                <div className="row">
                        <div className="col-md-6">
                          <img className="img-fluid" style={{'maxWidth' : 70 + '%', 'margin' : '0 auto', 'display' : 'block'}} src={process.env.PUBLIC_URL+"/img/duvidas.png"} alt="" title=""/>
                        </div> 

                        <div className="col-md-6">
                            <div className="accordion">
                                <input type="radio" name="select" className="accordion-select" defaultChecked />
                                <div className="accordion-title"><span>Em quanto tempo a loja fica pronta?</span></div>
                                <div className="accordion-content">O prazo para loja ficar pronta é de 7 dias úteis. No entanto é preciso criar uma conta no pagseguro, para associar à loja virtual.</div> 
                                <input type="radio" name="select" className="accordion-select" />
                                <div className="accordion-title"><span>Terei que pagar mais alguma coisa depois da loja paga?</span></div>
                                <div className="accordion-content">Depois que loja estiver totalmente pronta, o cliente vai pagar uma mensalidade referente a hospedagem + manutenção.</div> 
                                <input type="radio" name="select" className="accordion-select" />
                                <div className="accordion-title"><span>Preciso ser empresa para ter uma loja virtual?</span></div>
                                <div className="accordion-content">Não é preciso ser empresa para ter uma loja virtual, basta apenas ter uma conta no pagseguro no formato vendedor.</div> 
                                <input type="radio" name="select" className="accordion-select" />
                                <div className="accordion-title"><span>Qual a tecnologia utilizada na loja virtual?</span></div>
                                <div className="accordion-content">Utilizamos tecnologia de ponta: Laravel + Vue js</div> 
                                <input type="radio" name="select" className="accordion-select" />
                                <div className="accordion-title"><span>A loja é segura?</span></div>
                                <div className="accordion-content">Sim, pois nenhuma informação de cartão de crédito é guardado no banco de dados e as senhas são indecifráveis. Além disso dispomos de criptografia SSL.</div> 
                                <input type="radio" name="select" className="accordion-select" />
                                <div className="accordion-title"><span>Terei uma área administrativa para cadastrar os produtos?</span></div>
                                <div className="accordion-content">Sim, dispomos de uma área administrativa bem completa para que você possa fazer os ajustes necessários sem precisar de ninguém.</div> 
                            </div> 
                        </div> 
                        
                </div>

                </div>
            </section>

          </>
        );
      }

}